<template>
	<div class="hero-image">
		<slot>
			<div class="slider-overlay" />
			<picture>
				<source
					v-if="item.imagePortraitWebp"
					:srcset="item.imagePortraitWebp"
					type="image/webp"
					media="(max-width: 500px)"
				/>
				<source v-if="item.imagePortrait" :srcset="item.imagePortrait" media="(max-width: 500px)" />
				<source :srcset="item.imageWebp" type="image/webp" />
				<source :srcset="item.image" />
				<img class="slider-image" :src="item.image" :alt="item.imageAlt" />
			</picture>
		</slot>
	</div>
</template>

<script setup>
defineProps({
	item: {
		type: Object,
		default: () => {},
	},
	type: {
		type: String,
		default: '',
	},
});
</script>

<style lang="scss" scoped>
.slider-overlay {
	position: absolute;
	inset: 0;
	z-index: 2;
	background: rgb(0 0 0 / 20%);
}
</style>
